import { Stack } from 'expo-router';
import React from 'react';

import { AiDashboardPage } from '../../../llm-service/components/AiDashboardPage';

export default function AiDashboardRoute() {
    return (
        <>
            <Stack.Screen
                options={{
                    title: 'AI Dashboard',
                }}
            />
            <AiDashboardPage />
        </>
    );
}
